import { render } from "./FormularioRegistrarse.vue?vue&type=template&id=18a2c326&scoped=true"
import script from "./FormularioRegistrarse.vue?vue&type=script&lang=js"
export * from "./FormularioRegistrarse.vue?vue&type=script&lang=js"

import "./FormularioRegistrarse.vue?vue&type=style&index=0&id=18a2c326&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a2c326"]])

export default __exports__